import { Component, Input } from '@angular/core';
import { IValueWithName } from "libraries/pipes/configurable-table/compute-value.pipe";

@Component({
    selector: 'value-with-name',
    template: `
        <span>{{ valueWithName?.label }}</span>
        <ul>
            <li *ngFor="let item of valueWithName?.value; let i = index" class="value">
                {{ item }} - <span class="name">{{ valueWithName?.name[i] }}</span>
            </li>
        </ul>
    `,
    styles: [`
        .value {
            font-weight: bolder;
            list-style-type: disc;
        }

        .name {
            font-weight: normal;
        }
    `]
})
export class ValueWithNameComponent {
    @Input()
    public valueWithName: IValueWithName;
}
